import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { format } from 'date-fns';
import { ILeftHashRateFilter } from '@pages/Main/components/LeftHashRate/filter';
import { IBoeingIncomeAccount } from '@entities/boeing/IBoeingNewAccount';

export interface IBoeingIncomeAccountList {
  items: IBoeingIncomeAccount[];
  total_pages: number;
  total_items: number;
  current_page: number;
}

export const fetch = async (filters: ILeftHashRateFilter): Promise<IBoeingIncomeAccountList> => {
  let params = {};

  if (filters.dateFrom) {
    params = {
      ...params,
      date_from: format(new Date(filters.dateFrom), 'yyyy-MM-dd'),
    };
  }

  if (filters.dateTo) {
    params = {
      ...params,
      date_to: format(new Date(filters.dateTo), 'yyyy-MM-dd'),
    };
  }

  if (filters.perPage) {
    params = { ...params, page_size: filters.perPage };
  }

  if (filters.sort) {
    params = {
      ...params,
      sort_order: filters.sort.type,
      sort_by: filters.sort.column,
    };
  }

  const response = await api.get<IBoeingIncomeAccountList>(
    `${BI_BASE_URL}/boeing/table/new/accounts`,
    {
      params: {
        managers_ids: filters.managers,
        region: filters.regions,
        source: filters.sources,
        tag: filters.tags,
        page: filters.page,
        coins: filters.coins,
        ...params,
      },
    }
  );

  return response.data ?? [];
};

export const useBoeingNewAccountList = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
